module.exports = __webpack_public_path__ + "img/product-list_m4.eca7eda2.png";